var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronUpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    d: "M6.99639 9.6736C7.18375 9.48735 7.4372 9.38281 7.70139 9.38281C7.96558 9.38281 8.21903 9.48735 8.40639 9.6736L11.9964 13.2136L15.5364 9.6736C15.7238 9.48735 15.9772 9.38281 16.2414 9.38281C16.5056 9.38281 16.759 9.48735 16.9464 9.6736C17.0401 9.76657 17.1145 9.87717 17.1653 9.99903C17.216 10.1209 17.2422 10.2516 17.2422 10.3836C17.2422 10.5156 17.216 10.6463 17.1653 10.7682C17.1145 10.89 17.0401 11.0006 16.9464 11.0936L12.7064 15.3336C12.6134 15.4273 12.5028 15.5017 12.381 15.5525C12.2591 15.6033 12.1284 15.6294 11.9964 15.6294C11.8644 15.6294 11.7337 15.6033 11.6118 15.5525C11.49 15.5017 11.3794 15.4273 11.2864 15.3336L6.99639 11.0936C6.90266 11.0006 6.82827 10.89 6.7775 10.7682C6.72673 10.6463 6.70059 10.5156 6.70059 10.3836C6.70059 10.2516 6.72673 10.1209 6.7775 9.99903C6.82827 9.87717 6.90266 9.76657 6.99639 9.6736Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpIcon);
export default __webpack_public_path__ + "static/media/chevron_up-icon.fba65b3b9bac3e68aafd27834fa8bd8b.svg";
export { ForwardRef as ReactComponent };